<template>
  <div class="text-center">
    <div class="mb-10">
      <v-img
        src="/images/ocularlogo.svg"
        alt="Ocular Solution"
        style="width: 100px"
        class="mx-auto"
      ></v-img>
    </div>
    <div class="my-3">
      <v-progress-circular
        color="primary"
        indeterminate
        width="3"
      ></v-progress-circular>
    </div>
    <div>
      <h3 style="color: #444" class="font-weight-regular">
        {{$t('sessionLink.loading')}}
      </h3>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Loading extends Vue {}
</script>
